import { render, staticRenderFns } from "./SignUpInfo.vue?vue&type=template&id=1f8c4544&scoped=true"
import script from "./SignUpInfo.vue?vue&type=script&lang=js"
export * from "./SignUpInfo.vue?vue&type=script&lang=js"
import style0 from "./SignUpInfo.vue?vue&type=style&index=0&id=1f8c4544&prod&lang=scss"
import style1 from "./SignUpInfo.vue?vue&type=style&index=1&id=1f8c4544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c4544",
  null
  
)

export default component.exports